/**
 * Recover something human-readable from a clip's storage key.
 *
 * Keys look like `intake/<intakeId>/<uuid>_<safeName>`, so drop the path and
 * the uuid prefix. Works after a reload, when the original File is long gone
 * and the storage key is all we have.
 */
export function clipDisplayName(storagePath: string): string {
  const leaf = storagePath.split('/').pop() ?? storagePath;
  const underscore = leaf.indexOf('_');
  return underscore > 0 ? leaf.slice(underscore + 1) : leaf;
}
